(function () {
  'use strict';

  function parseFavorites() {
    try {
      var favorites = JSON.parse(window.localStorage.getItem('zs-favoritos') || '[]');
      return Array.isArray(favorites) ? favorites.filter(Boolean).slice(0, 24) : [];
    } catch (error) {
      return [];
    }
  }

  function formatHandle(handle) {
    return String(handle || '')
      .split('-')
      .filter(Boolean)
      .map(function (part) { return part.charAt(0).toUpperCase() + part.slice(1); })
      .join(' ');
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-AR', {
        style: 'currency',
        currency: currency || 'ARS',
        maximumFractionDigits: 0
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '';
    }
  }

  function initPremiumHeader(header) {
    if (!header || header.dataset.zsHeaderReady === 'true') return;
    header.dataset.zsHeaderReady = 'true';

    if (header.classList.contains('zs-premium-header--sticky')) {
      var sectionWrapper = header.closest('.shopify-section-group-header-group');
      if (sectionWrapper) sectionWrapper.classList.add('zs-premium-header-wrapper--sticky');
    }

    var mobileMenu = header.querySelector('[data-zs-mobile-menu]');
    var favoritesDrawer = header.querySelector('[data-zs-favorites-drawer]');
    var backdrop = header.querySelector('[data-zs-header-backdrop]');
    var menuOpen = header.querySelector('[data-zs-menu-open]');
    var menuClose = header.querySelector('[data-zs-menu-close]');
    // Hay más de un disparador de favoritos (barra superior y menú móvil).
    var favoritesOpeners = Array.prototype.slice.call(header.querySelectorAll('[data-zs-favorites-open]'));
    var favoritesOpen = favoritesOpeners[0] || null;
    var favoritesClose = header.querySelector('[data-zs-favorites-close]');
    var favoritesClear = header.querySelector('[data-zs-favorites-clear]');
    var favoritesList = header.querySelector('[data-zs-favorites-list]');
    var searchWrap = header.querySelector('[data-zs-search-wrap]');
    var searchToggle = header.querySelector('[data-zs-search-toggle]');
    var lastTrigger = null;

    function closeSearch(restoreFocus) {
      if (header.classList.contains('zs-premium-header--desktop-search') && window.matchMedia('(min-width: 990px)').matches) return;
      if (!searchWrap || searchWrap.hidden) return;
      searchWrap.hidden = true;
      if (searchToggle) {
        searchToggle.setAttribute('aria-expanded', 'false');
        searchToggle.setAttribute('aria-label', 'Abrir buscador');
        if (restoreFocus) searchToggle.focus();
      }
    }

    function openSearch() {
      if (!searchWrap) return;
      closeAllMegaMenus();
      searchWrap.hidden = false;
      if (searchToggle) {
        searchToggle.setAttribute('aria-expanded', 'true');
        searchToggle.setAttribute('aria-label', 'Cerrar buscador');
      }
      var searchInput = searchWrap.querySelector('input[type="search"]');
      if (searchInput) window.requestAnimationFrame(function () { searchInput.focus(); });
    }

    if (searchToggle) searchToggle.addEventListener('click', function () {
      if (searchWrap && searchWrap.hidden) openSearch();
      else closeSearch(false);
    });

    function updateBodyLock() {
      var hasOpenDrawer = (mobileMenu && !mobileMenu.hidden) || (favoritesDrawer && !favoritesDrawer.hidden);
      document.body.classList.toggle('zs-header-locked', Boolean(hasOpenDrawer));
      if (backdrop) backdrop.hidden = !hasOpenDrawer;
    }

    function openDrawer(drawer, trigger) {
      if (!drawer) return;
      closeAllMegaMenus();
      [mobileMenu, favoritesDrawer].forEach(function (candidate) {
        if (candidate && candidate !== drawer) {
          candidate.hidden = true;
          candidate.setAttribute('aria-hidden', 'true');
        }
      });
      lastTrigger = trigger || null;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      updateBodyLock();
      var focusTarget = drawer.querySelector('button, a, summary');
      if (typeof trapFocus === 'function') trapFocus(drawer, focusTarget || drawer);
      else if (focusTarget) focusTarget.focus();
    }

    function closeDrawer(drawer, trigger) {
      if (!drawer) return;
      drawer.hidden = true;
      drawer.setAttribute('aria-hidden', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      updateBodyLock();
      if (typeof removeTrapFocus === 'function') removeTrapFocus(lastTrigger || trigger);
      else if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
      lastTrigger = null;
    }

    if (menuOpen) menuOpen.addEventListener('click', function () { openDrawer(mobileMenu, menuOpen); });
    if (menuClose) menuClose.addEventListener('click', function () { closeDrawer(mobileMenu, menuOpen); });
    favoritesOpeners.forEach(function (opener) {
      opener.addEventListener('click', function () {
        renderFavorites(header);
        openDrawer(favoritesDrawer, opener);
      });
    });
    if (favoritesClose) favoritesClose.addEventListener('click', function () { closeFavorites(); });

    function closeFavorites() {
      closeDrawer(favoritesDrawer, null);
      favoritesOpeners.forEach(function (opener) { opener.setAttribute('aria-expanded', 'false'); });
    }
    if (favoritesClear) favoritesClear.addEventListener('click', function () {
      window.localStorage.setItem('zs-favoritos', '[]');
      document.dispatchEvent(new CustomEvent('zs:favorites:changed', { detail: { handles: [] } }));
      renderFavorites(header);
    });
    if (favoritesList) favoritesList.addEventListener('click', function (event) {
      var removeButton = event.target.closest('[data-zs-favorite-remove]');
      if (!removeButton) return;
      var nextFavorites = parseFavorites().filter(function (handle) { return handle !== removeButton.dataset.handle; });
      window.localStorage.setItem('zs-favoritos', JSON.stringify(nextFavorites));
      document.dispatchEvent(new CustomEvent('zs:favorites:changed', { detail: { handles: nextFavorites } }));
      renderFavorites(header);
    });
    if (backdrop) backdrop.addEventListener('click', function () {
      if (mobileMenu && !mobileMenu.hidden) closeDrawer(mobileMenu, menuOpen);
      if (favoritesDrawer && !favoritesDrawer.hidden) closeFavorites();
    });

    function closeAllMegaMenus(except) {
      header.querySelectorAll('[data-zs-nav-item]').forEach(function (item) {
        if (item === except) return;
        var trigger = item.querySelector('[data-zs-mega-trigger]');
        var panel = item.querySelector('[data-zs-mega]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }

    header.querySelectorAll('[data-zs-nav-item]').forEach(function (item) {
      var trigger = item.querySelector('[data-zs-mega-trigger]');
      var panel = item.querySelector('[data-zs-mega]');
      if (!trigger || !panel) return;

      function openMega() {
        closeAllMegaMenus(item);
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }

      function closeMega() {
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
      }

      trigger.addEventListener('click', function () {
        if (trigger.getAttribute('aria-expanded') === 'true') closeMega();
        else openMega();
      });
      item.addEventListener('mouseenter', openMega);
      item.addEventListener('mouseleave', closeMega);
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) closeMega();
      });
    });

    document.addEventListener('click', function (event) {
      if (!header.contains(event.target)) closeAllMegaMenus();
      if (searchWrap && !searchWrap.hidden && !searchWrap.contains(event.target) && (!searchToggle || !searchToggle.contains(event.target))) closeSearch(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAllMegaMenus();
      closeSearch(true);
      if (mobileMenu && !mobileMenu.hidden) closeDrawer(mobileMenu, menuOpen);
      if (favoritesDrawer && !favoritesDrawer.hidden) closeFavorites();
    });

    initUtility(header);
    updateFavoriteCount(header);

    var mainBar = header.querySelector('.zs-header-main');
    var navBar = header.querySelector('.zs-main-nav-wrap');

    // Publica la posición real del borde inferior de la barra principal para
    // que el desplegable de búsqueda se ancle a ella en vez de a un valor fijo.
    function updateHeaderMetrics() {
      if (!mainBar) return;
      var metricBar = navBar && window.matchMedia('(min-width: 990px)').matches ? navBar : mainBar;
      var bottom = Math.max(0, Math.round(metricBar.getBoundingClientRect().bottom));
      header.style.setProperty('--zs-header-main-bottom', bottom + 'px');
    }

    if (mainBar && typeof ResizeObserver === 'function') {
      new ResizeObserver(updateHeaderMetrics).observe(mainBar);
    }
    window.addEventListener('resize', updateHeaderMetrics, { passive: true });
    updateHeaderMetrics();

    var ticking = false;
    function updateScrolledState() {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
      updateHeaderMetrics();
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateScrolledState);
    }, { passive: true });
    updateScrolledState();

    window.addEventListener('storage', function (event) {
      if (event.key === 'zs-favoritos') updateFavoriteCount(header);
    });
    document.addEventListener('zs:favorites:changed', function () { updateFavoriteCount(header); });
  }

  function initUtility(header) {
    var utility = header.querySelector('[data-zs-utility]');
    if (!utility || utility.dataset.autoplay !== 'true') return;
    if (utility.dataset.marquee === 'true') return;
    var items = Array.prototype.slice.call(utility.querySelectorAll('[data-zs-utility-item]'));
    var toggle = utility.querySelector('[data-zs-utility-toggle]');
    if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (toggle) toggle.hidden = true;
      return;
    }
    var activeIndex = 0;
    var speed = Number(utility.dataset.speed) || 5000;
    var timer = null;
    var manuallyPaused = false;

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (manuallyPaused) return;
      timer = window.setInterval(function () {
        if (window.innerWidth >= 990 || document.hidden) return;
        items[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % items.length;
        items[activeIndex].classList.add('is-active');
      }, speed);
    }

    if (toggle) toggle.addEventListener('click', function () {
      manuallyPaused = !manuallyPaused;
      toggle.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
      toggle.setAttribute('aria-label', manuallyPaused ? 'Reanudar mensajes' : 'Pausar mensajes');
      toggle.textContent = manuallyPaused ? '▶' : 'Ⅱ';
      if (manuallyPaused) stop();
      else start();
    });

    start();
  }

  function updateFavoriteCount(header) {
    var count = parseFavorites().length;
    header.querySelectorAll('[data-zs-favorites-count]').forEach(function (badge) {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  }

  function renderFavorites(header) {
    var list = header.querySelector('[data-zs-favorites-list]');
    var clearButton = header.querySelector('[data-zs-favorites-clear]');
    if (!list) return;
    var handles = parseFavorites();
    if (!handles.length) {
      list.replaceChildren();
      var emptyMessage = document.createElement('p');
      emptyMessage.textContent = list.dataset.empty || 'Todavía no guardaste productos.';
      list.appendChild(emptyMessage);
      if (clearButton) clearButton.hidden = true;
      return;
    }
    if (clearButton) clearButton.hidden = false;

    list.innerHTML = '<p>Cargando favoritos…</p>';
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var availableProducts = products.filter(Boolean);
      if (!availableProducts.length) {
        list.innerHTML = '<p>No pudimos encontrar los productos guardados.</p>';
        return;
      }

      list.innerHTML = '';
      availableProducts.forEach(function (product) {
        var item = document.createElement('article');
        item.className = 'zs-favorite-item';
        var link = document.createElement('a');
        link.className = 'zs-favorite-item__link';
        link.href = product.url || '/products/' + product.handle;

        var image = document.createElement('img');
        image.src = typeof product.featured_image === 'string' ? product.featured_image : (product.featured_image && product.featured_image.src) || '';
        image.alt = product.title || formatHandle(product.handle);
        image.width = 66;
        image.height = 78;
        image.loading = 'lazy';

        var content = document.createElement('span');
        var title = document.createElement('strong');
        title.textContent = product.title || formatHandle(product.handle);
        var price = document.createElement('span');
        price.textContent = formatMoney(product.price, product.currency || 'ARS');
        content.appendChild(title);
        content.appendChild(document.createElement('br'));
        content.appendChild(price);
        link.appendChild(image);
        link.appendChild(content);

        var actions = document.createElement('span');
        actions.className = 'zs-favorite-item__actions';
        var quickButton = document.createElement('button');
        quickButton.type = 'button';
        quickButton.textContent = 'Elegir y agregar';
        quickButton.dataset.zsQuickOpen = '';
        quickButton.dataset.productHandle = product.handle;
        quickButton.dataset.productUrl = product.url || '/products/' + product.handle;
        var removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.textContent = 'Quitar';
        removeButton.dataset.zsFavoriteRemove = '';
        removeButton.dataset.handle = product.handle;
        actions.append(quickButton, removeButton);
        item.append(link, actions);
        list.appendChild(item);
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-zs-premium-header]').forEach(initPremiumHeader);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('[data-zs-premium-header]');
    if (header) initPremiumHeader(header);
  });
})();
